import PageConfirmEmail from "./ConfirmEmail";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(PageConfirmEmail);
